module.exports = __webpack_public_path__ + "img/sponsor-02.a9a2b9df.png";